<template>
  <div class="cart-icon" @click="$emit('click')">
    <span class="cart-symbol">🛒</span>
    <span v-if="count > 0" class="cart-count">{{ displayCount }}</span>
    <span v-if="showLabel" class="cart-label">{{ $t('common.cart') }}</span>
  </div>
</template>

<script>
export default {
  name: 'CartIcon',
  props: {
    count: {
      type: Number,
      default: 0
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    displayCount() {
      return this.count > 99 ? '99+' : this.count
    }
  }
}
</script>

<style scoped>
.cart-icon {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 8px;
  transition: all 0.3s;
}

.cart-icon:hover {
  color: #d4af37;
}

.cart-symbol {
  font-size: 20px;
}

.cart-count {
  position: absolute;
  top: 0;
  right: 0;
  background: #d4af37;
  color: #1a1a1a;
  font-size: 10px;
  font-weight: bold;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

.cart-label {
  font-size: 14px;
  color: #ccc;
}

.cart-icon:hover .cart-label {
  color: #d4af37;
}

@media (max-width: 768px) {
  .cart-label {
    display: none;
  }
}
</style>
